module.exports = __webpack_public_path__ + "img/upper_arm.1477f273.png";